import { get } from "api"
import { PaginationResponse } from "types/common/axios"
import { CouponListRequest, CouponListResponse } from "types/coupon"

// 获取优惠卷列表
export const getCouponList = (params: CouponListRequest) => {
    return get<CouponListRequest, PaginationResponse<CouponListResponse>>("/api/coupon/list", params)
}
